import React, { useState, useEffect } from 'react'

import { Button, Card, Form, Icon, notification, Typography } from 'antd'
import { Formik } from 'formik'
import { get } from 'lodash'
import * as yup from 'yup'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import FormHeader from '../../components/FormHeader/FormHeader'
import { validRule, RULES } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

const UpdatePermissions = ({ match, history }) => {
  // Params url
  const { id } = match.params

  // UseStates
  const [formLayout] = useState('vertical')
  const [formValues, setFormValues] = useState({})

  // Mount/Umount component
  useEffect(() => {
    const hasAccess = validRule(RULES.PROFILE) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }

    retrieveData(id)
  }, [])

  // Cruds
  async function retrieveData(id) {
    try {
      const response = await request(api.retrieveProfiles(id))
      setFormValues({
        ...response.data
      })
    } catch (error) {
      console.tron.log(error)
    }
  }

  async function updateActionTypes(payload) {
    try {
      console.tron.log('updateCustomerTypes')
      const { id, data } = payload
      await request(api.updateActionTypes(id, data))
      notification.success({
        description: getMessage('successPermissions'),
        message: getMessage('sweetAlerts.success')
      })
      setFormValues({})
      history.goBack()
    } catch (error) {
      console.tron.log(error)
    }
  }

  // Form/formik config
  const form = {
    initialValues: formValues,
    yupValidationCreate: yup.object().shape({
      actionTypesName: yup
        .string()
        .max(60)
        .typeError('must be string')
        .required(getMessage('isRequired', getMessage('description')))
    }),
    yupValidationUpdate: yup.object().shape({
      actionTypesName: yup
        .string()
        .max(60)
        .typeError('must be string')
        .required(getMessage('isRequired', getMessage('description')))
    }),
    onSubmit: async (values) => {
      const data = {
        typeName: get(values, 'actionTypesName', ''),
        active: get(values, 'actionTypesActive', true)
      }

      const payload = {
        id,
        data
      }
      updateActionTypes(payload)
    }
  }
  // Header
  function renderHeader(submitForm) {
    const hasAccess = validRule(RULES.PROFILE)

    return (
      <div className="default-header-div">
        <Typography.Title className="default-header-title" level={3}>
          {getMessage('updatePermissions')}
        </Typography.Title>
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          <div className="default-header-buttons">
            <Button onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            {hasAccess && (
              <Button type="primary" onClick={() => submitForm()}>
                {getMessage('update')}
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  // Main component
  return (
    <>
      <Formik
        enableReinitialize
        validationSchema={!id ? form.yupValidationCreate : form.yupValidationUpdate}
        initialValues={formValues}
        onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
          form.onSubmit(values, setSubmitting, setFieldError, resetForm)
        }
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ handleSubmit, submitForm }) => {
          return (
            <Form className="login-form" layout={formLayout} onSubmit={handleSubmit}>
              {renderHeader(submitForm)}

              <Card className="ant-card gx-card ant-card-bordered">
                <FormHeader title={getMessage('customer.tab.info')} orientation="left" type="horizontal" />

                <FormHeader title={getMessage('permissions')} orientation="left" type="horizontal" />
              </Card>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}

export default UpdatePermissions
